<template>
  <panel :title="details" :withBody="isDisplayDetails || showCardInfoStatus" :withFooter="isDisplayDetails || showCardInfoStatus" :to="getEditLink()">
    <loader slot="panel-section" :loading="loading"/>
    <overlay :show="removed" slot="panel-section" :label="removeAction === 'delete' ? 'Enviado para exclusão' : 'Vínculo removido'"/>
    <modal-product-remove-confirmation slot="panel-section" :product="product" :typeAction="removeAction" v-model="modalProductRemoveConfirmFlag" v-on:confirm="removeAction === 'delete' ? productDeleteConfirm() : productRemoveConfirm()"/>
    <modal-product-action-reprocess slot="panel-section" :product="product" :typeAction="typeAction" v-model="modalProductActionReprocessFlag" v-on:confirm="productActionReprocess(typeAction)"/>
    <div slot="header-right">
      <span v-if="isDisplayList" class="badge status statusDetails" :class="stockStatus">Estoque</span>
      <span v-if="isDisplayList" class="badge status statusDetails" :class="priceStatus">Preço</span>
      <span  class="badge status statusDetails hint hint--left" :data-label="getLastSyncMessage(product.date)" :class="product.status">{{ $t(`${product.status}.label`) }}</span>

      <button-actions :identifier="`product-item-actions-${product._id.$oid}`">
        <li>
          <router-link :to="getEditLink()">Editar</router-link>
        </li>
        <li v-if="product.message || product.variations[0].price.message || product.variations[0].stock.message">
          <span @click="showInfoStatusMessage">Ver mensagens</span>
        </li>
        <li>
          <span @click="modalProductRemoveConfirmFlag = true, removeAction = 'unlink'">Remover vínculo</span>
        </li>
        <li>
          <span @click="modalProductRemoveConfirmFlag = true, removeAction = 'delete'">Remover produto</span>
        </li>
        <li v-if="product.status === 'active'">
          <span @click="modalProductActionReprocessFlag = true, typeAction = 'stock'">Reprocessar estoque</span>
        </li>
        <li v-if="product.status === 'active'">
          <span @click="modalProductActionReprocessFlag = true, typeAction = 'price'">Reprocessar preço</span>
        </li>
      </button-actions>
    </div>
    <div>
      <div class="l-row" v-show="showCard">
        <div class="l-col-2@md img-product">
          <img :src="image" class="img-rounded" v-if="image"/>
          <i class="icon icon-image2 no-photo" v-else></i>
        </div>

        <blockquote class="l-col-4@md box">
          <div class="l-row attributes">
            <div class="l-col-4@md">
              <div class="margin">
                <strong>Condição</strong>
                {{ $t(`mercadoLivre.conditions.${product.condition}.label`) | attribute }}
              </div>
            </div>
            <div class="l-col-4@md">
              <div class="margin">
                <strong>Tipo</strong>
                {{ $t(`mercadoLivre.types.${product.type}.label`) | attribute }}
              </div>
            </div>
            <div class="l-col-4@md">
              <div class="margin">
                <strong>Envio</strong>
                {{ $t(`mercadoLivre.shippingOptions.${product.shippingMode}.label`) | attribute }}
              </div>
            </div>
            <div class="l-col-4@md">
              <div class="margin">
                <strong>{{ product.variations.length === 1 ? 'Variação' : 'Variações' }}</strong>
                <span class="link" @click="showVariationModalFlag = true">{{ product.variations.length === 1 ? product.variations[0].sku : 'Ver todas' }}</span>

                <variation-modal v-model="showVariationModalFlag" :product="product"/>
              </div>
            </div>
            <div class="l-col-4@md" v-if="product.code">
              <div class="margin">
                <strong>Código</strong>
                <a  v-if="product.link" :href="product.link"  target="_blank">
                  <span class="hint hint--bottom" data-label="Clique para acessar no marketplace"> {{ product.code }} <i class="icon-new-tab"/></span>
                </a>
                <span v-else>{{ product.code }}</span>
              </div>
            </div>
            <div class="l-col-4@md">
              <div class="margin">
                <strong>{{ $t('productGroupedId.label') }}</strong>
                {{ product.productId | attribute }}
              </div>
            </div>
            <div class="l-col-4@md">
              <div class="margin">
                <strong>{{ $t('createdAt.label') }}</strong>
                {{ product.createdAt | moment('DD/MM/YYYY HH:mm') | attribute }}
              </div>
            </div>
            <div class="l-col-4@md">
              <div class="margin">
                <strong>{{ $t('typeCheckout.label') }}</strong>
                <span class="badge queue">{{ product.typeCheckout ? 'Sim' : 'Não' }}</span>
              </div>
            </div>
            <div class="l-col-4@md">
              <div class="margin">
                <strong>{{ $t('mercadoLivre.shippingFree.label') }}</strong>
                <span class="badge queue">{{ product.shippingFree ? 'Sim' : 'Não' }}</span>
              </div>
            </div>
            <div class="l-col-12@md">
              <div class="margin">
                <strong>Conta</strong>
                {{ getAccount() }}
              </div>
            </div>
          </div>
        </blockquote>

        <blockquote class="l-col-3@md box">
          <div class="l-row">
            <div class="l-col-6@md attributes">
              <div class="margin">
                <strong>{{ $t('stock.label') }}</strong>
                {{ quantity | attribute }}
              </div>
            </div>
            <div class="l-col-6@md attributes">
              <div class="margin">
                <strong>Status Estoque</strong>
                <span class="badge status" :class="stockStatus">{{ $t(stockStatus).label }}</span>
              </div>
            </div>
          </div>
        </blockquote>

        <blockquote class="l-col-3@md box">
          <div class="l-row">
            <div class="l-col-6@md">
              <div class="margin">
                <strong>{{ $t('price.current.label') }}</strong>

                <span v-if="!isAllowUpdatePrice">{{ price | currency }}</span>
                <editable v-else :label="$t('price.current.label')" type="price" v-model="price" :onConfirm="confirmedUpdate"/>
              </div>
            </div>
            <div class="l-col-6@md">
              <div class="margin">
                <strong>Status Preço</strong>
                <span class="badge status" :class="priceStatus">{{ $t(priceStatus).label }}</span>
              </div>
            </div>
          </div>
        </blockquote>

      </div>

      <transition name="fade">
        <status-message-card v-if="showCardInfoStatus" :product="product" :module="module" v-on:close="showInfoStatusMessage()"/>
      </transition>

    </div>
    <div slot="footer">
      <module-icon :identifier="product.source.identifier"/>
    </div>
  </panel>
</template>

<script>
  import { cloneDeep } from 'lodash'
  import Editable from '@/components/template/Editable/Base'
  import ModuleIcon from '@/components/template/ModuleIcon'
  import StatusMessageCard from '@/components/shared/StatusMessageCard'
  import { mapActions } from 'vuex'
  import { mapFields } from 'vuex-map-fields'
  import Panel from '../../template/Panel'
  import moment from 'moment'
  import ButtonActions from '@/components/template/ButtonActions'
  import ModalProductRemoveConfirmation from '@/components/marketplace/mercadoLivre/ModalProductRemoveConfirmation'
  import ModalProductActionReprocess from '@/components/marketplace/mercadoLivre/ModalProductActionReprocess'
  import Loader from '@/components/template/Loader'
  import Overlay from '@/components/template/Overlay'
  import api from '@/api'
  import notifier from '@/notifier'
  import VariationModal from '@/components/marketplace/mercadoLivre/VariationModal'

  export default {
    data: () => ({
      showCard: true,
      showCardInfoStatus: false,
      quantity: 0,
      modalProductRemoveConfirmFlag: false,
      modalProductActionReprocessFlag: false,
      loading: false,
      removed: false,
      removeAction: 'unlink',
      showVariationModalFlag: false,
      typeAction: null
    }),
    props: {
      product: {
        type: Object,
        required: true
      },
      module: {
        type: Object,
        required: true
      }
    },
    mounted () {
      this.product.variations.map(variation => {
        this.quantity += variation.stock.quantity
      })

      this.fetchAccounts({
        options: {
          active: true
        }
      })
    },
    methods: {
      ...mapActions('itemsSelected', [
        'add',
        'remove',
        'clear'
      ]),
      ...mapActions('mercadoLivreAccounts', [
        'fetchAccounts'
      ]),
      confirmedUpdate (previousValue, newValue) {
        this.loading = true

        const pricePreviousCurrent = {}

        for (let i in this.product.variations) {
          pricePreviousCurrent[this.product.variations[i].sku] = this.product.variations[i].price.previous
          if (this.product.variations[i].price.previous <= newValue) {
            this.product.variations[i].price.previous = 0
          }
          this.product.variations[i].price.current = newValue
        }

        const product = cloneDeep(this.product)
        product._id = product._id.$oid

        api.mercadoLivre.updateProductPrice(product)
          .then(product => {
            for (const variation of product.variations) {
              const referenceVariation = this.product.variations.find(refVariation => refVariation.sku === variation.sku)

              referenceVariation.price.status = variation.price.status
            }

            notifier.success('Preço de todas variações atualizado com sucesso.', 'Atualização de preço')
          })
          .catch(() => {
            for (let i in this.product.variations) {
              this.product.variations[i].price.previous = pricePreviousCurrent[this.product.variations[i].sku]
              this.product.variations[i].price.current = previousValue
            }

            notifier.error('Erro na atualização de preço das variações.', 'Erro')
          })
          .finally(() => { this.loading = false })
      },
      showInfoStatusMessage () {
        this.showCard = !this.showCard
        this.showCardInfoStatus = !this.showCardInfoStatus
      },
      showCardProduct () {
        this.showCardInfoStatus = false
        this.showCard = true
      },
      getLastSyncMessage (date) {
        const formatted = moment(date).format('DD/MM/YYYY HH:mm')
        return `Sincronizado em ${formatted}`
      },
      onSelect (selected) {
        if (selected) {
          this.add(this.product)
        } else {
          this.remove(this.product)
        }
      },
      getEditLink () {
        if (this.product.status !== 'queue') {
          return { name: 'editAnnouncement', params: { identifier: this.product._id.$oid } }
        }

        return null
      },
      productRemoveConfirm () {
        this.loading = true
        api.mercadoLivre.deleteProduct(this.product._id.$oid, this.product.account.identifier)
          .then(() => {
            this.modalProductRemoveConfirmFlag = false
            this.removed = true
            notifier.success('Vínculo removido. O anúncio continua no Mercado Livre.', 'Removido')
          })
          .catch(error => {
            let message = 'Falha ao remover o vínculo com o anúncio.'
            if (error.response.data.message) {
              message = error.response.data.message
            }
            notifier.error(message, 'Não removido')
          })
          .finally(() => {
            this.loading = false
          })
      },
      productDeleteConfirm () {
        this.loading = true
        api.mercadoLivre.deleteAnnouncement(this.product._id.$oid, this.product.account.identifier)
          .then(() => {
            this.modalProductRemoveConfirmFlag = false
            this.removed = true
            notifier.success('Produto enviado para exclusão no PlaceMarket e no Mercado Livre.', 'Em processamento')
          })
          .catch(error => {
            let message = 'Falha ao remover o produto.'
            if (error.response.data.message) {
              message = error.response.data.message
            }
            notifier.error(message, 'Não removido')
          })
          .finally(() => {
            this.loading = false
          })
      },
      async productActionReprocess (typeAction) {
        this.loading = true

        const options = {
          type: typeAction,
          identifier: this.product._id.$oid
        }

        await api.mercadoLivre.reprocess(this.module.type, this.module.identifier, options, this.product.account.identifier)
          .then((productReprocessed) => {
            this.modalProductActionReprocessFlag = false

            if (typeAction === 'price') {
              for (let i in this.product.variations) {
                this.product.variations[i].price.status = productReprocessed.variations[i].price.status
              }
            }

            if (typeAction === 'stock') {
              for (let i in this.product.variations) {
                this.product.variations[i].stock.status = productReprocessed.variations[i].stock.status
              }
            }

            notifier.success('Anúncio reprocessado com sucesso.', 'Sucesso')
          })
          .catch(error => {
            let message = 'Falha ao reprocessar anúncio.'
            if (error.response.data.message) {
              message = error.response.data.message
            }
            notifier.error(message, 'Erro')
          })
          .finally(() => {
            this.loading = false
            this.typeAction = null
          })
      },
      getAccount () {
        const account = this.mercadoLivreAccounts.find(account => account.identifier === this.product.account.identifier)

        let accountName = ''

        if (account !== undefined) {
          accountName = `${account.name} - ${account.nickname}`
        }

        return accountName
      }
    },
    computed: {
      ...mapFields({
        mercadoLivreAccounts: 'mercadoLivreAccounts.accounts'
      }),
      price () {
        let highestPrice = 0

        this.product.variations.map(variation => {
          if (variation.price.current > highestPrice) {
            highestPrice = variation.price.current
          }
        })

        return highestPrice
      },
      isAllowUpdatePrice () {
        for (let i in this.product.variations) {
          if (this.product.variations[i].price.type !== 'custom' || this.product.status === 'queue') {
            return false
          }
        }

        return true
      },
      isDisplayList () {
        return this.listInitial === 'displayList'
      },
      listInitial () {
        return this.$parent.listInitial
      },
      isDisplayDetails () {
        return this.listInitial === 'displayDetails'
      },
      details () {
        let title = []

        if (this.product.title) {
          title.push(this.product.title.length > 120 ? this.product.title.substring(0, 120).replace('-', '').trim() + '...' : this.product.title)
        }
        if (this.listInitial === 'displayList') {
          if (this.product.type) {
            title.push(`Tipo: ${this.$t(`mercadoLivre.types.${this.product.type}.label`)}`)
          }

          if (this.product.shippingMode) {
            title.push(`Envio: ${this.$t(`mercadoLivre.shippingOptions.${this.product.shippingMode}.label`)}`)
          }
        }

        return title.join(' | ')
      },
      image () {
        if (!this.product.variations[0].images.length) {
          return ''
        }

        return this.product.variations[0].images[0].url
      },
      stockStatus () {
        const hasError = (this.product.variations.filter(variation => variation.stock.status === 'error')).length
        if (hasError) {
          return 'error'
        }

        const hasPending = (this.product.variations.filter(variation => variation.stock.status === 'pending')).length
        if (hasPending) {
          return 'pending'
        }

        const hasQueued = (this.product.variations.filter(variation => variation.stock.status === 'queue')).length
        if (hasQueued) {
          return 'queue'
        }

        return 'success'
      },
      priceStatus () {
        const hasError = (this.product.variations.filter(variation => variation.price.status === 'error')).length
        if (hasError) {
          return 'error'
        }

        const hasPending = (this.product.variations.filter(variation => variation.price.status === 'pending')).length
        if (hasPending) {
          return 'pending'
        }

        const hasQueued = (this.product.variations.filter(variation => variation.price.status === 'queue')).length
        if (hasQueued) {
          return 'queue'
        }

        return 'success'
      }
    },
    components: {
      Panel,
      ModuleIcon,
      StatusMessageCard,
      ButtonActions,
      ModalProductActionReprocess,
      ModalProductRemoveConfirmation,
      Loader,
      Overlay,
      VariationModal,
      Editable
    }
  }
</script>

<style lang="sass" scoped>
  .img-product
    text-align: center

    &::after
      content: ''
      height: 100%
      display: inline-block
      vertical-align: middle

    img
      max-width: 100%
      margin:  5px 0 16px
      max-height: 150px
      display: inline-block
      vertical-align: middle

  .notsent
    filter: grayscale(100%)

  .title
    text-align: center
    color: white
    font-weight: bold
    font-size: 16px

  .icon-size
    font-size: 14px

  .blocksize
    display: table
    height: 100%
    width: 100%

  .ul-align
    margin-top: 15px

  .status
    width: 100%
    text-align: center
    font-size: 12px
    padding: 4px 8px
    line-height: 1
    vertical-align: middle
    display: block
    margin-bottom: 10px

  .statusDetails
    display: inline

  .no-photo
    font-size: 150px
    color: #a9a9a9
    margin: 5px 0 16px

  strong
    display: block
    margin-bottom: 5px

  .margin
    margin: 10px 0 15px 10px

  .fade-enter-active
    transition: opacity .7s

  .fade-enter
    opacity: 0

  .btn-icon
    float: right

  .icon-new-tab
    margin-bottom: 2px

</style>



// WEBPACK FOOTER //
// AnnouncementCard.vue?671cce1b